// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zRm1","right":"styles_right__3MXag"};